import API from "Common/Client/endpoint";
import api from "Common/Client/Interceptor";

export const fetchLearnerDashboardData = async (token) => {
  try {
    const response = await api.get(API.dashboard.learnerDashboard); 
    return response.data;
  } catch (error) {
    console.error("Error fetching Learner dashboard data:", error);
    throw error;
  }
};
